import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "../assets/crmPermissionCategoryUsers.module.css";

const CrmPermissionCategoryUsers = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiFailed, setApiFailed] = useState(false);

  useEffect(() => {
    loadCategoryUsers();
  }, [id]);

  const loadCategoryUsers = async () => {
    try {
      const baseUrl = process.env.REACT_APP_API_URL;
      setLoading(true);
      const response = await fetch(`${baseUrl}/api/permissions/category/${id}/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setCategory(data.data.category);
          setUsers(data.data.users);
          setApiFailed(false);
        } else {
          throw new Error(data.message || 'Failed to load category users');
        }
      } else {
        throw new Error('Failed to load category users');
      }
    } catch (error) {
      console.error("Failed to load category users:", error);
      setApiFailed(true);
      
      // Fallback to mock data
      const mockCategories = {
        1: { id: 1, name: "User Management" },
        2: { id: 2, name: "Role Management" },
        3: { id: 3, name: "Permission Management" },
        4: { id: 4, name: "Guardian Management" }
      };
      
      const mockUsers = [
        { id: 1, name: "John Smith", email: "john.smith@example.com", role: "System Administrator" },
        { id: 2, name: "Jane Doe", email: "jane.doe@example.com", role: "Senior Management" },
        { id: 3, name: "Bob Johnson", email: "bob.johnson@example.com", role: "Client" }
      ];
      
      setCategory(mockCategories[id] || { id: parseInt(id), name: "Unknown Category" });
      setUsers(mockUsers);
      // Error handled silently - no toast shown
    } finally {
      setLoading(false);
    }
  };

  if (loading && !category) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default panel-standard">
              <div className="panel-body text-center">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!category) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default panel-standard">
              <div className="panel-body text-center">
                <p>Category not found</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <span onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer', color: '#337ab7' }}>Dashboard</span>
          </li>
          <li className="breadcrumb-item">
            <span onClick={() => navigate('/permissions')} style={{ cursor: 'pointer', color: '#337ab7' }}>CRM Permissions</span>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Users with {category.name} Permissions
          </li>
        </ol>
      </nav>

      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default panel-standard">
            <div className="panel-heading panel-title">
              <h3>Users with {category.name} Permissions</h3>
            </div>
            <div className="panel-body">
              {users.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(users) ? users.map((user) => (
                        <tr key={user.id}>
                          <td>{user.id}</td>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          <td>{user.role}</td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan="4">No users available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center">
                  <p>No users found with {category.name} permissions</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrmPermissionCategoryUsers; 